/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  VzzYJk: 'Create',
  'navigation.universal-create.menuItemLoading': 'Menu item is loading',
  'platform.navigation-experiences.universal-create.remote-section-heading': 'Suggestions',
  'platform.navigation-experiences.universal-create.show-less': 'Less',
  'platform.navigation-experiences.universal-create.show-more': 'More',
  'platform.navigation-experiences.universal-create.suggestion.section-heading':
    '{count, plural, one {Suggestion} other {Suggestions}}',
  'platform.navigation.universalCreate.ctaButton': 'Got it',
  'platform.navigation.universalCreate.ctaHeading': 'Create more, instantly',
  'platform.navigation.universalCreate.ctaMsg1.new':
    'You can now initiate more types of work directly from Atlassian Home.',
  'platform.navigation.universalCreate.ctaMsg2.new':
    'Use the Create button to begin a wider variety of work directly from Atlassian Home.',
  'platform.navigation.universalCreate.ctaMsg3':
    'Kick off more kinds of work directly from Atlassian Home with the Create button.',
  'universal-create.loom-video-menu-item.create-loom-video': 'Loom video',
  'universal-create.loom-video-menu-item.share-video': 'Share',
};
